import { FC } from "react";
import s from "./style.module.css";

export const Layer: FC = ({ children }) => {
  return <div className={s.layer}>{children}</div>;
};
